import type { BossStatus } from '../../core/boss/boss-fight';

/**
 * Animation of JEFE-2 El Jinete from the state of the core (GDD §9.2, issue #111), as a pure function: the render only
 * reads the fight. Priority: the retreat, the flour reaction to a decoy hit, the stagger of the phase transition, hiding
 * behind the portraits (Los Caballeros), the throw (for a moment after a horseshoe leaves) and the paso fino at rest.
 */
export type Jefe2Animation = 'PASO_FINO' | 'THROW' | 'FLOUR_HIT' | 'STAGGER' | 'HIDE' | 'RETREAT';

/** How long the throw and the flour reaction last, in ticks. */
export const THROW_TICKS = 20;
export const FLOUR_TICKS = 40;

export interface Jefe2Input {
  status: BossStatus;
  phaseName: string;
  ticksSinceThrow: number | null;
  ticksSinceHit: number | null;
}

export function jefe2Animation(input: Jefe2Input): Jefe2Animation {
  if (input.status === 'retreating' || input.status === 'done') return 'RETREAT';
  if (input.ticksSinceHit !== null && input.ticksSinceHit < FLOUR_TICKS) return 'FLOUR_HIT';
  if (input.status === 'transition') return 'STAGGER';
  if (input.phaseName === 'LOS_CABALLEROS') return 'HIDE';
  if (input.ticksSinceThrow !== null && input.ticksSinceThrow < THROW_TICKS) return 'THROW';
  return 'PASO_FINO';
}

/** The four-beat gait: the phase of each leg (front left, back left, front right, back right) in a cycle of 0..1. */
export const GAIT_OFFSETS: readonly number[] = [0, 0.25, 0.5, 0.75];

/** Swing in radians of a leg at a moment of the gait cycle. */
export const legSwing = (cycle: number, leg: number, amplitude = 0.5): number =>
  Math.sin(2 * Math.PI * (cycle + GAIT_OFFSETS[leg]!)) * amplitude;
